import { useEffect, useRef } from 'react';
import type { WebappResponse } from '@eventbrite/event-listing-service-client';

import { sendEventViewTracking } from '@/src/listings/utils/eventViewTracking';
import { addRecentView } from '@/src/listings/utils/utils';

type UseEventViewTrackingEffectArgs = {
  pageContext: WebappResponse | null | undefined;
  isPreview: boolean | undefined;
};

export function useEventViewTrackingEffect({ pageContext, isPreview }: UseEventViewTrackingEffectArgs) {
  const eventViewTrackedEventIdRef = useRef<string | null>(null);

  useEffect(() => {
    const eventId = pageContext?.basicInfo?.id;

    if (isPreview || !eventId) {
      return;
    }

    if (eventViewTrackedEventIdRef.current === eventId) {
      return;
    }

    eventViewTrackedEventIdRef.current = eventId;
    sendEventViewTracking({ eventId });
    addRecentView(eventId);
  }, [pageContext, isPreview]);
}
